<template>
  <div>
    <base-header class="pb-7 pt-5 pt-md-7 bg-gradient-info">
      <b-row class="align-items-center">
        <b-col>
          <h6 class="h2 text-white d-inline-block mb-0">
            <i class="fa fa-users-cog mr-2"></i>Manajemen Akses Pengguna
          </h6>
          <p class="text-white-50 mb-0 mt-1" style="font-size:0.85rem;">
            Kelola akun pengguna per role &mdash; reset password, edit biodata, hapus akun, generate akun bulk
          </p>
        </b-col>
      </b-row>

      <b-row class="mt-4">
        <b-col xl="3" md="6">
          <stats-card type="gradient-danger" icon="fa fa-user-shield" class="mb-4">
            <h5 class="card-title text-uppercase text-muted mb-0">Admin</h5>
            <span class="h2 font-weight-bold mb-0">{{ counts.admin || 0 }}</span>
          </stats-card>
        </b-col>
        <b-col xl="3" md="6">
          <stats-card type="gradient-warning" icon="fa fa-university" class="mb-4">
            <h5 class="card-title text-uppercase text-muted mb-0">Dekan (Fakultas)</h5>
            <span class="h2 font-weight-bold mb-0">{{ counts.dekan || 0 }}</span>
          </stats-card>
        </b-col>
        <b-col xl="3" md="6">
          <stats-card type="gradient-primary" icon="fa fa-book-reader" class="mb-4">
            <h5 class="card-title text-uppercase text-muted mb-0">Kaprodi</h5>
            <span class="h2 font-weight-bold mb-0">{{ counts.kaprodi || 0 }}</span>
          </stats-card>
        </b-col>
        <b-col xl="3" md="6">
          <stats-card type="gradient-info" icon="fa fa-user-tag" class="mb-4">
            <h5 class="card-title text-uppercase text-muted mb-0">Surveyor</h5>
            <span class="h2 font-weight-bold mb-0">{{ counts.surveyor || 0 }}</span>
          </stats-card>
        </b-col>
      </b-row>
    </base-header>

    <b-container fluid class="mt--6 pb-5">
      <!-- Filter & Actions -->
      <b-card no-body>
        <b-card-header class="border-0">
          <b-row align-v="center">
            <b-col><h3 class="mb-0">Daftar Pengguna</h3></b-col>
            <b-col cols="auto" class="text-right">
              <b-dropdown size="sm" variant="success" right>
                <template #button-content>
                  <i class="fa fa-magic"></i> Generate Akun
                </template>
                <b-dropdown-item @click="generateAccounts('all')">
                  <i class="fa fa-globe"></i> Semua (Fakultas + Prodi)
                </b-dropdown-item>
                <b-dropdown-item @click="generateAccounts('fakultas')">
                  <i class="fa fa-university"></i> Hanya Fakultas
                </b-dropdown-item>
                <b-dropdown-item @click="generateAccounts('prodi')">
                  <i class="fa fa-book-reader"></i> Hanya Prodi
                </b-dropdown-item>
              </b-dropdown>
            </b-col>
          </b-row>
        </b-card-header>
        <b-card-body class="pt-2">
          <b-row>
            <b-col md="3">
              <b-form-group label="Filter Role" label-size="sm" class="mb-2">
                <b-form-select v-model="filter.role" :options="roleOptions" size="sm" @change="loadUsers"></b-form-select>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group label="Pencarian" label-size="sm" class="mb-2">
                <b-form-input v-model="filter.search" size="sm" placeholder="Cari username, nama, email, no.telp..." @keyup.enter="loadUsers"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="3" class="d-flex align-items-end mb-2">
              <b-button-group size="sm" class="w-100">
                <b-button variant="outline-secondary" @click="resetFilter">
                  <i class="fa fa-redo"></i> Reset
                </b-button>
                <b-button variant="info" @click="loadUsers">
                  <i class="fa fa-search"></i> Cari
                </b-button>
              </b-button-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <small class="text-muted">
                Default tampilkan: <strong>Admin / Kaprodi / Dekan / Ketua UPT</strong>.
                Untuk Surveyor pilih role <em>Surveyor</em>. Akun Alumni tidak bisa di-reset password (login pakai NPM+tgl lahir).
              </small>
            </b-col>
          </b-row>
        </b-card-body>
      </b-card>

      <!-- Table -->
      <b-card no-body class="mt-3">
        <div class="table-responsive">
          <table class="table table-sm table-hover align-items-center mb-0">
            <thead class="thead-light">
              <tr>
                <th>Username</th>
                <th>Nama Lengkap</th>
                <th>Role</th>
                <th>Email</th>
                <th>No. Telp</th>
                <th>Status</th>
                <th class="text-right">Aksi</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="!users.length">
                <td colspan="7" class="text-center text-muted py-4">Tidak ada user ditemukan</td>
              </tr>
              <tr v-for="u in users" :key="u.id_user">
                <td><code>{{ u.username }}</code></td>
                <td>{{ u.nama_lengkap || '-' }}</td>
                <td><b-badge :variant="roleVariant(u.role_key)">{{ u.nm_role || u.role_key }}</b-badge></td>
                <td><small>{{ u.email || '-' }}</small></td>
                <td><small>{{ u.tlpn_hp || '-' }}</small></td>
                <td>
                  <b-badge :variant="u.status == 1 ? 'success' : 'secondary'">
                    {{ u.status == 1 ? 'Aktif' : 'Nonaktif' }}
                  </b-badge>
                </td>
                <td class="text-right">
                  <b-button size="sm" variant="outline-primary" @click="editUser(u)" title="Edit biodata">
                    <i class="fa fa-edit"></i>
                  </b-button>
                  <b-button v-if="u.role_key !== 'alumni'" size="sm" variant="outline-warning" @click="resetPassword(u)" title="Reset password">
                    <i class="fa fa-key"></i>
                  </b-button>
                  <b-button v-if="u.role_key !== 'alumni'" size="sm" variant="outline-danger" @click="deleteUser(u)" title="Hapus user">
                    <i class="fa fa-trash"></i>
                  </b-button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="card-footer d-flex justify-content-between align-items-center" v-if="totalUsers > perPage">
          <small class="text-muted">{{ totalUsers }} user total</small>
          <b-pagination v-model="filter.page" :total-rows="totalUsers" :per-page="perPage" size="sm" class="mb-0" @change="onPageChange"></b-pagination>
        </div>
      </b-card>
    </b-container>

    <!-- Edit Bio Modal -->
    <b-modal id="modal-edit-user" size="lg" title="Edit Biodata User" @ok="submitEdit">
      <div v-if="editError" class="alert alert-danger">{{ editError }}</div>
      <b-form-group label="Username">
        <b-form-input :value="editUserData.username" disabled></b-form-input>
        <small class="text-muted">Tidak bisa diubah</small>
      </b-form-group>
      <b-form-group label="Nama Lengkap">
        <b-form-input v-model="editUserData.nama_lengkap"></b-form-input>
      </b-form-group>
      <b-row>
        <b-col md="6">
          <b-form-group label="Email">
            <b-form-input v-model="editUserData.email" type="email"></b-form-input>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group label="No. Telp">
            <b-form-input v-model="editUserData.tlpn_hp"></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="6">
          <b-form-group label="Jenis Kelamin">
            <b-form-select v-model="editUserData.jk" :options="jkOptions"></b-form-select>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group label="Status">
            <b-form-select v-model="editUserData.status" :options="[{value:1,text:'Aktif'},{value:0,text:'Nonaktif'}]"></b-form-select>
          </b-form-group>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import BaseHeader from "@/components/admin/BaseHeader";
import axios from "axios";
import authHeader from "@/services/auth-header";
import { baseURL } from "@/constants";

export default {
  name: "UserManagement",
  components: { BaseHeader },
  data: function () {
    return {
      users: [],
      counts: {},
      totalUsers: 0,
      perPage: 50,
      filter: { role: '', search: '', page: 1, default: '1' },
      editUserData: { id_user: '', username: '', nama_lengkap: '', email: '', tlpn_hp: '', jk: '', status: 1 },
      editError: '',
      jkOptions: [
        { value: '', text: '-- Pilih --' },
        { value: 'L', text: 'Laki-laki' },
        { value: 'P', text: 'Perempuan' }
      ],
      roleOptions: [
        { value: '', text: 'Default (Admin/Kaprodi/Dekan/Ketua UPT)' },
        { value: 'admin', text: 'Admin' },
        { value: 'dekan', text: 'Dekan' },
        { value: 'kaprodi', text: 'Kaprodi' },
        { value: 'ketua_upt', text: 'Ketua UPT' },
        { value: 'surveyor', text: 'Surveyor' },
        { value: 'alumni', text: 'Alumni' }
      ]
    };
  },
  created: function () { this.loadUsers(); },
  methods: {
    loadUsers: function () {
      var self = this;
      self.$store.commit("SHOW_LOADING", "Memuat user...");
      var params = {
        page: self.filter.page,
        per_page: self.perPage,
        search: self.filter.search,
        default: self.filter.role ? '0' : '1',
      };
      if (self.filter.role) params.role = self.filter.role;
      axios.get(baseURL + "/admin/users", { headers: authHeader(), params: params })
        .then(function (res) {
          self.users = res.data.data || [];
          self.totalUsers = res.data.total || 0;
          self.counts = res.data.counts_by_role || {};
          self.$store.commit("HIDE_LOADING");
        })
        .catch(function (err) {
          self.$store.commit("HIDE_LOADING");
          var msg = (err.response && err.response.data && err.response.data.message) || "Gagal load user";
          self.$swal({ icon: "error", title: "Error", text: msg });
        });
    },
    onPageChange: function (page) {
      this.filter.page = page;
      this.loadUsers();
    },
    resetFilter: function () {
      this.filter = { role: '', search: '', page: 1, default: '1' };
      this.loadUsers();
    },
    editUser: function (u) {
      this.editError = '';
      this.editUserData = {
        id_user: u.id_user,
        username: u.username,
        nama_lengkap: u.nama_lengkap || '',
        email: u.email || '',
        tlpn_hp: u.tlpn_hp || '',
        jk: u.jk || '',
        status: u.status
      };
      this.$bvModal.show("modal-edit-user");
    },
    submitEdit: function (bvEvt) {
      bvEvt.preventDefault();
      var self = this;
      var id = self.editUserData.id_user;
      var payload = {
        nama_lengkap: self.editUserData.nama_lengkap,
        email: self.editUserData.email,
        tlpn_hp: self.editUserData.tlpn_hp,
        jk: self.editUserData.jk,
        status: self.editUserData.status
      };
      self.$store.commit("SHOW_LOADING", "Menyimpan...");
      axios.put(baseURL + "/admin/users/" + id, payload, { headers: authHeader() })
        .then(function () {
          self.$store.commit("HIDE_LOADING");
          self.$bvModal.hide("modal-edit-user");
          self.$swal({ icon: "success", title: "Tersimpan", timer: 1200, showConfirmButton: false });
          self.loadUsers();
        })
        .catch(function (err) {
          self.$store.commit("HIDE_LOADING");
          self.editError = (err.response && err.response.data && err.response.data.message) || "Gagal menyimpan";
        });
    },
    resetPassword: function (u) {
      var self = this;
      self.$swal({
        title: "Reset password user ini?",
        html: "Username: <code>" + u.username + "</code><br><br>" +
              "<small class='text-muted'>Password akan di-reset ke default (kode prodi/fakultas) atau random untuk admin.</small>",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Ya, reset",
        cancelButtonText: "Batal",
        confirmButtonColor: "#fb6340"
      }).then(function (result) {
        if (!result.value) return;
        self.$store.commit("SHOW_LOADING", "Mereset password...");
        axios.post(baseURL + "/admin/users/" + u.id_user + "/reset-password", {}, { headers: authHeader() })
          .then(function (res) {
            self.$store.commit("HIDE_LOADING");
            self.$swal({
              icon: "success",
              title: "Password Direset",
              html: "Username: <code>" + res.data.username + "</code><br>" +
                    "Password baru: <code><strong>" + res.data.new_password + "</strong></code><br><br>" +
                    "<small class='text-muted'>Berikan password ini ke pengguna untuk login.</small>"
            });
          })
          .catch(function (err) {
            self.$store.commit("HIDE_LOADING");
            var msg = (err.response && err.response.data && err.response.data.message) || "Gagal";
            self.$swal({ icon: "error", title: "Gagal", text: msg });
          });
      });
    },
    deleteUser: function (u) {
      var self = this;
      self.$swal({
        title: "Hapus user permanen?",
        html: "Username: <code>" + u.username + "</code><br>" +
              "<span class='text-danger'>Akun + profil + token akan dihapus permanen, tidak bisa di-restore.</span>",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        confirmButtonText: "Ya, hapus permanen",
        cancelButtonText: "Batal"
      }).then(function (result) {
        if (!result.value) return;
        self.$store.commit("SHOW_LOADING", "Menghapus user...");
        axios.delete(baseURL + "/admin/users/" + u.id_user, { headers: authHeader() })
          .then(function () {
            self.$store.commit("HIDE_LOADING");
            self.$swal({ icon: "success", title: "Dihapus", timer: 1200, showConfirmButton: false });
            self.loadUsers();
          })
          .catch(function (err) {
            self.$store.commit("HIDE_LOADING");
            var msg = (err.response && err.response.data && err.response.data.message) || "Gagal";
            self.$swal({ icon: "error", title: "Gagal", text: msg });
          });
      });
    },
    generateAccounts: function (type) {
      var self = this;
      var labels = { all: 'Fakultas + Prodi', fakultas: 'Fakultas', prodi: 'Prodi' };
      self.$swal({
        title: "Generate akun " + labels[type] + "?",
        text: "Akun yang sudah ada akan di-skip. Akun baru pakai format adminKODE / KODE.",
        icon: "info",
        showCancelButton: true,
        confirmButtonText: "Ya, generate",
        cancelButtonText: "Batal"
      }).then(function (result) {
        if (!result.value) return;
        self.$store.commit("SHOW_LOADING", "Generate akun...");
        axios.post(baseURL + "/admin/users/generate-accounts", { type: type }, { headers: authHeader() })
          .then(function (res) {
            self.$store.commit("HIDE_LOADING");
            self.$swal({
              icon: "success",
              title: "Selesai",
              html: "Fakultas baru: <strong>" + res.data.created_fakultas + "</strong><br>" +
                    "Prodi baru: <strong>" + res.data.created_prodi + "</strong><br>" +
                    "Skip (sudah ada): <strong>" + res.data.skipped + "</strong>"
            });
            self.loadUsers();
          })
          .catch(function (err) {
            self.$store.commit("HIDE_LOADING");
            var msg = (err.response && err.response.data && err.response.data.message) || "Gagal";
            self.$swal({ icon: "error", title: "Gagal", text: msg });
          });
      });
    },
    roleVariant: function (r) {
      var m = { admin: "danger", kaprodi: "primary", dekan: "warning", surveyor: "info", alumni: "secondary", ketua_upt: "success" };
      return m[r] || "light";
    }
  }
};
</script>
